import { Flex } from "src/components/Flex.tsx";

export const AppFallback = () => {
  return (
    <Flex
      css={{
        width: "100vw",
        height: "100vh",
        alignItems: "center",
        justifyContent: "center",
      }}
    />
  );
};
